<template>
  <div class="button-update" @click="onClick">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'ButtonUpdate',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  emits: ['clicked'],
  methods: {
    onClick() {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.button-update {
  align-items: center;
  background-color: variables.$color-grey-blue-dark;
  border-radius: variables.$border-radius-small;
  color: variables.$color-text-white-70;
  cursor: pointer;
  display: flex;
  height: variables.$size-button-small;
  padding: 0 8px;
  white-space: nowrap;
}
</style>
